import { action } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import HotelSettingsCompetitorsController from 'lumen/controllers/hotel/settings/competitors';

export default class HotelSettingsCompetitorsGeneralController extends HotelSettingsCompetitorsController {
  @service access;
  @service hotelAndMarket;
  @service intl;

  @tracked activeTab = 'compset';

  /**
   * Keeps track of whether the user saved changes. Used to reload the app if the user navigates away
   */
  @tracked hasSavedChanges = false;
  @tracked hasUnsavedChanges = false;

  get canEditCurrentCompset() {
    if (this.activeTab === 'compset') {
      return this.access.canEditAppCompset;
    }

    return this.access.canEditRmsCompset;
  }

  get pageTitle() {
    return this.activeTab === 'compset'
      ? this.intl.t('settings.competitors.compset')
      : this.intl.t('settings.competitors.RMS_compset');
  }

  @action
  onSaveChangesSuccess() {
    this.hasSavedChanges = true;
  }

  @action
  setHasUnsavedChanges(hasUnsavedChanges) {
    this.hasUnsavedChanges = hasUnsavedChanges;
  }
}
